import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../../App";
import { CheckCircle2 } from "lucide-react";
import { Button } from "../../components/ui/button";

export default function SalonSubscriptionSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("checking");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { nav("/salon/dashboard"); return; }
    let cancelled = false;
    const poll = async () => {
      try {
        const r = await axios.get(`${API}/salons/subscription/status/${sid}`);
        if (cancelled) return;
        if (r.data.payment_status === "paid") setStatus("paid");
        else if (tries < 8) setTimeout(() => setTries((t) => t + 1), 2000);
        else setStatus("pending");
      } catch {
        if (tries < 8) setTimeout(() => setTries((t) => t + 1), 2000);
        else setStatus("error");
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [tries, params, nav]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6" data-testid="salon-subscription-success">
      <div className="max-w-md text-center">
        {status === "paid" ? (
          <>
            <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#EAF3EC] text-[#4A6D50] mb-6">
              <CheckCircle2 className="h-7 w-7" />
            </div>
            <div className="text-[10px] kt-tracking-wider uppercase text-[#6F6B66] mb-2">Welcome</div>
            <h1 className="font-serif text-4xl text-[#383633] tracking-tight mb-4">
              Your Hairtu Professional subscription is active.
            </h1>
            <p className="text-[#6F6B66] mb-8">
              You can start unlimited client assessments right away.
            </p>
          </>
        ) : status === "pending" ? (
          <>
            <div className="text-[10px] kt-tracking-wider uppercase text-[#6F6B66] mb-2">Finalizing</div>
            <h1 className="font-serif text-3xl text-[#383633] tracking-tight mb-4">
              Payment received — activation in progress.
            </h1>
            <p className="text-[#6F6B66] mb-8">
              This usually finishes within a minute. You can safely open your dashboard.
            </p>
          </>
        ) : status === "error" ? (
          <>
            <h1 className="font-serif text-3xl text-[#383633] tracking-tight mb-4">
              We could not confirm the payment status.
            </h1>
            <p className="text-[#6F6B66] mb-8">Return to your dashboard — subscription state will refresh automatically.</p>
          </>
        ) : (
          <div className="text-[#6F6B66] kt-tracking uppercase text-sm">Verifying payment…</div>
        )}
        <Button onClick={() => nav("/salon/dashboard")} data-testid="salon-success-continue"
          className="rounded-full bg-[#383633] hover:bg-[#4A4238] text-white h-12 px-8 text-xs kt-tracking uppercase">
          Open salon dashboard →
        </Button>
      </div>
    </div>
  );
}
